// @ts-check
import { gql, useQuery } from '@apollo/client';
import { i18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import React from 'react';
import mixpanel from 'mixpanel-browser';
import { Crisp } from "crisp-sdk-web";

import activateLocale from './activateLocale';

/**
 * Provides the user's locale.
 * Requires ApolloProvider for querying the user.
 * @param {object} props
 * @param {React.ReactNode} props.children
 */

export default function UserLocaleProvider({ children }) {
  const mixpanelToken = import.meta.env.VITE_MIXPANEL_PPROJECT_TOKEN;
  const CRISP_WORKSPACE_ID = import.meta.env.VITE_CRISP_WORKSPACE_ID;
  Crisp.configure(CRISP_WORKSPACE_ID,{autoload: true});
  
  mixpanel.init(mixpanelToken,{
    persistence: 'localStorage',    // set persistence to local storage
    debug: true,                    // enable debug log in console
});
  const { data } = useQuery(query);
  const locale = data?.currentUser?.interfaceLocale || 'en';
  const workspaceName = data?.mySession?.currentWorkspace?.owner?.name;
  const user = data?.currentUser;
  const userId = user?.userId;

  React.useEffect(() => {
    activateLocale(locale);
  }, [locale]);
  
  React.useEffect(() => {
    if (userId && Crisp){

      // your user signs in and tracks a sign in event
      Crisp.user.setEmail(user.email);
      Crisp.user.setNickname(user.name);
      Crisp.user.setCompany(workspaceName);
      // if (user.email.includes('@bottlebooks.me')){
      // }
      
      // upon sign in, identify the user with their ID
      // ensure future events sent from the user have distinct_id 12345
      Crisp.session.setData({
        user_id : user.userId,
        
        // plan : "free"
      });
      // Crisp.chat.show();
      Crisp.setZIndex(99999);
      // Crisp.chat.setHelpdeskView();
    }
    // if (userId && mixpanel){
    //   mixpanel.track('Import tool session started');
    //   mixpanel.identify(user.userId);
    //   mixpanel.people.set_once({
    //     name: user.name,
    //     email: user.email
    //   });
    //   mixpanel.start_session_recording({record_collect_fonts:true, record_mask_text_selector: ''});
    //   }

  }, [userId, mixpanelToken, CRISP_WORKSPACE_ID]);


  return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
}

const query = gql`
  query UserLocaleProvider {
    currentUser {
      userId
      interfaceLocale
      name: fullName
      email
    }
    mySession {
      currentWorkspace {
        workspaceId
        owner {
          name
        }
      }
    }

  }
`;
